import {cachedValueCreate} from "@wix/devzai-utils-common";

class MediaFeaturesDetectorSingleton {

    private cachedSupportsHover = cachedValueCreate(() => {
        return window.matchMedia('(hover: hover)').matches && window.matchMedia('(pointer: fine)').matches;
    })
    public get supportsHover () { return this.cachedSupportsHover.getValue() }

    private cachedSupportsEyeDropper = cachedValueCreate(() => {
        return 'EyeDropper' in window;
    });
    public get supportsEyeDropper () { return this.cachedSupportsEyeDropper.getValue() }

}

export const MediaFeaturesDetector = new MediaFeaturesDetectorSingleton();